<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
	<div>
		<select
				:id="id"
				:disabled="disabled"
				:name="name"
				:value="modelValue"
				class="input-element"
				v-bind="$attrs"
				@input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
		>
			<option value=""></option>
			<option
					v-for="option in options"
					:key="option.value + option.label"
					:value="option.value"
			>
				{{ option.label }}
			</option>
		</select>
	</div>
</template>

<script lang="ts" setup>
	import {
		formSelectProps,
		sharedFormElementProps
	} from '~/components/forms/sharedFormInputProps';

	defineProps({
		...sharedFormElementProps,
		...formSelectProps
	});

	defineEmits(['update:modelValue']);

	defineOptions({
		inheritAttrs: false
	});

</script>

<style scoped>
	div {
		width: 100%;
		overflow: auto;
	}
</style>
